import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { IExamState } from "../hoc/stdLiveWrapper";
import { useQuery } from "react-query";
import { developAxios } from "../../axios.config";
import downloadIcon from "../Assets/Images/download.svg";
import { Pie } from "react-chartjs-2";
import { Dropdown } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);

interface ILiveDataResponse {
	totalStudentsWhoEnrolled: number;
	examDate?: string;
	examStatus: "live" | "ended";
	courseName: string;
	examName: string;
}
export default function DownloadDataHybrid({
	setSubmittedUsers,
	// unSubmittedCount,
	setEnrolledStudents,
}: IExamState) {
	const [isLoading, setIsLoading] = useState(false);
	const [disableExportButton, setDisableExportButton] = useState(false);
	const [pieQuiz, setPieQuiz] = useState<{
		labels: Array<string>;
		datasets: Array<{
			label: string;
			data: Array<number>;
			backgroundColor: Array<string>;
		}>;
	}>();
	const [pieCoding, setPieCoding] = useState<{
		labels: Array<string>;
		datasets: Array<{
			label: string;
			data: Array<number>;
			backgroundColor: Array<string>;
		}>;
	}>();
	const [examType, setExamType] = useState<"quiz" | "coding">("quiz");
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);

	const { _id: id } = useParams<{ _id: string }>();

	const style = {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginTop: "30px",
	};
	const card = {
		height: "300px",
		width: "80%",
		border: "1px solid",
		borderRadius: "10px",
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
	};

	useQuery(
		["get-submitted-exam-results", id],
		() => {
			return developAxios(localStorage.getItem("token") || "").get<{
				result: Array<{
					_id: string;
					user: {
						email: string;
						firstName: string;
					};
				}>;
			}>(`/hybrid-exam/getSubmittedUserByExamId/${id}`);
		},
		{
			refetchInterval: 20000,
			onSuccess: ({ data }) => {
				setSubmittedUsers && setSubmittedUsers(data.result.length);
			},
		}
	);

	useEffect(() => {
		developAxios(localStorage.getItem("token") || "")
			.get<ILiveDataResponse>(
				`/live-exams/get-live-students/${id}?type=hybrid`
			)
			.then(({ data }) => {
				setEnrolledStudents &&
					setEnrolledStudents(data.totalStudentsWhoEnrolled);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	useEffect(() => {
		function getType(val: string) {
			switch (val) {
				case "eightyToOneHundred":
					return "80% - 100%";

				case "sixtyToEighty":
					return "60% - 80%";

				case "thirtyToSixty":
					return "30% - 60%";

				default:
					return "0% - 30%";
			}
		}

		function getColor(val: string) {
			switch (val) {
				case "eightyToOneHundred":
					return "#FF6384";

				case "sixtyToEighty":
					return "#F1AF13";

				case "thirtyToSixty":
					return "#62B170";

				default:
					return "#E97D30";
			}
		}

		developAxios(localStorage.getItem("token") || "")
			.get<{
				quiz: {
					zeroToThirty: string;
					thirtyToSixty: string;
					sixtyToEighty: string;
					eightyToOneHundred: string;
				};
				coding: {
					zeroToThirty: string;
					thirtyToSixty: string;
					sixtyToEighty: string;
					eightyToOneHundred: string;
				};
			}>(`/live-exams/get-exam-heat-map/${id}?type=hybrid`)
			.then(({ data }) => {
				let labels: Array<string> = [];
				let num_data: Array<number> = [];
				let bg_color: Array<string> = [];
				Object.keys(data.quiz).forEach((val) => {
					labels.push(getType(val));
					//@ts-ignore
					num_data.push(parseFloat(data.quiz[val]));
					bg_color.push(getColor(val));
				});

				let pieChartData = {
					labels,
					datasets: [
						{
							label: "# of vote",
							data: num_data,
							backgroundColor: bg_color,
						},
					],
				};
				setPieQuiz(pieChartData);
				labels = [];
				num_data = [];
				bg_color = [];

				Object.keys(data.coding).forEach((val) => {
					labels.push(getType(val));
					//@ts-ignore
					num_data.push(parseFloat(data.coding[val]));
					bg_color.push(getColor(val));
				});
				pieChartData = {
					labels,
					datasets: [
						{
							label: "# of vote",
							data: num_data,
							backgroundColor: bg_color,
						},
					],
				};
				setPieCoding(pieChartData);
			})
			.catch((e) => {
				console.error(e);
			});
	}, []);

	function downloadFile(tab: number) {
		const type = tab === 2 ? "submitted" : "unsubmitted";

		setDisableExportButton(true);
		fetch(
			`${process.env.REACT_APP_BASE_URL}/${
				tab === 2
					? `hybrid-exam/downloadSubmittedUsersByExamId`
					: `hybrid-exam/downloadUnSubmittedUsersByExamId`
			}/${id}`,
			{
				headers: {
					Authorization: `Bearer ${
						localStorage.getItem("token") || ""
					}`,
				},
			}
		)
			.then((res) => res.blob())
			.then((blob) => {
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", `${type}_${id}_file.xlsx`);
				document.body.appendChild(link);
				link.click();
			})
			.catch((err) => {
				alert(`Unable to download file ${type}_${id}_file.xlsx`);
			})
			.finally(() => setDisableExportButton(false));
	}

	return (
		<div className="downloadData">
			<div className="downloadBtn mt-3">
				<div className="exam-type-container">
					<select
						onChange={(e) => {
							let val = e.target.value;
							if (val === "quiz" || val === "coding") {
								setExamType(val);
							}
						}}
						value={examType}
					>
						<option value="quiz">Quiz</option>
						<option value="coding">Coding</option>
					</select>
				</div>
				<div
					style={{
						display: "flex",
					}}
				>
					<div className="submittedBtn">
						<button
							id="buttn"
							className="flex bg-[#1ad598] w-full py-2 px-3 rounded items-center text-white"
							onClick={() => downloadFile(2)}
							disabled={disableExportButton}
						>
							Submitted data{" "}
							<span>
								<img
									width={25}
									height={25}
									className="downloadIcon ml-2"
									src={downloadIcon}
									alt=""
								/>
							</span>
						</button>
					</div>
					<div className="unsubmitedBtn">
						<button
							className="flex bg-[#db5aee] w-full py-2 px-3 rounded items-center text-white"
							onClick={() => downloadFile(3)}
							disabled={disableExportButton}
						>
							Unsubmitted data{" "}
							<span>
								<img
									width={25}
									height={25}
									className="downloadIcon ml-2"
									src={downloadIcon}
									alt=""
								/>
							</span>
						</button>
					</div>
				</div>
			</div>

			<div style={style}>
				<div style={card} className="pie-charts">
					{" "}
					{pieQuiz && pieCoding && (
						<Pie
							data={examType === "quiz" ? pieQuiz : pieCoding}
							options={{
								maintainAspectRatio: false,
								responsive: true,
							}}
						/>
					)}
				</div>
			</div>
		</div>
	);
}

DownloadDataHybrid.defaultProps = {
	setSubmittedUsers: (count: number) => {},
	setEnrolledStudents: (count: number) => {},
};
